import angular from 'angular';
import { CurrentUser } from 'Roblox';
import avatarModule from '../avatarModule';

/*
    Controls the asset list on the avatar page
*/

function avatarItemsController(
  $scope,
  $log,
  cursorPaginationService,
  avatarConstantService,
  avatarUrlConstants,
  $document,
  $q,
  avatarTypeService,
  recommendationsConstants
) {
  'ngInject';

  $log.debug('avatarItemsController');
  $scope.isEmotesEnabled = false;
  $scope.loading = false;
  $scope.items = [];
  $scope.emptyMessage = '';
  let itemIdLookup = {};

  const pagingParameter = 'assetTypeId';
  const loadedItemType = 'Asset';
  let assetsPager = null;
  function onLoadSuccess(items) {
    const assets = [];
    const assetTypeId = assetsPager.getPagingParameter(pagingParameter);
    let assetTypeName;
    if ($scope.isEmotesEnabled) {
      assetTypeName = avatarTypeService.getAssetTypeName(assetTypeId);
    } else {
      assetTypeName = $scope.getAssetTypeName(assetTypeId);
    }

    if ($scope.recommendationsData) {
      $scope.recommendationsData.showRecommendations = true;
      $scope.recommendationsData.recommendationType =
        recommendationsConstants.recommendationTypes.assets;
      $scope.recommendationsData.recommendationSubtype = assetTypeId;
    }

    angular.forEach(items, function(inventoryItem) {
      const item = {};
      item.name = inventoryItem.Item.Name;
      item.id = inventoryItem.Item.AssetId;
      item.type = loadedItemType;
      $scope.addItemThumbnailAndLink(item);
      if ($scope.$parent.updateItemSelected) {
        $scope.$parent.updateItemSelected(item);
      }
      item.expired = inventoryItem.UserItem && inventoryItem.UserItem.IsRentalExpired;
      item.thumbnail = inventoryItem.Thumbnail;
      item.assetType = {
        id: assetTypeId,
        name: assetTypeName
      };

      // Don't list expired items
      if (item.expired) {
        $log.debug(`${item.name  } is expired!`);
        return;
      }

      // Don't add duplicate items
      if (!itemIdLookup[item.id]) {
        itemIdLookup[item.id] = true;
        assets.push(item);
      } else {
        $log.debug(`${item.name  } is a duplicate`);
      }
    });

    [].push.apply($scope.items, assets);

    if (!assetsPager.hasNextPage()) {
      $log.debug("Doesn't have next page, loading recommendations");
      $scope.recommendationsData.showRecommendations = true;
    } else {
      $scope.recommendationsData.showRecommendations = false;
      $scope.$emit('manualInfiniteScrollCheck');
    }
  }

  assetsPager = cursorPaginationService.createPager({
    limitName: 'itemsPerPage',
    sortOrder: cursorPaginationService.sortOrder.Desc,
    pageSize: 30,
    loadPageSize: 50,

    getDataListFromResponse(response) {
      return $q(function(resolve, reject) {
        resolve(response.Data ? response.Data.Items : []);
      });
    },

    getNextPageCursorFromResponse(response) {
      return response.Data ? response.Data.nextPageCursor : null;
    },

    getErrorsFromResponse(response) {
      return response.isValid
        ? []
        : [
            {
              code: 0,
              message: response.Data || response.error || ''
            }
          ];
    },

    getCacheKeyParameters(params) {
      return {
        assetTypeId: params.assetTypeId
      };
    },

    getRequestUrl() {
      return avatarUrlConstants.www.inventoryJson;
    },

    beforeLoad(pageNumber, pageParameters) {},

    loadSuccess: onLoadSuccess,

    loadError(error) {
      $scope.systemFeedback.error(avatarConstantService.assets.couldNotLoadList);
    }
  });

  $scope.getNextPage = function() {
    if ($scope.selectedTab.tabType !== 'Assets') {
      return;
    }

    if (!assetsPager.canLoadNextPage()) {
      return;
    }

    const request = assetsPager.loadNextPage();
    $scope.loading = true;
    request.then(
      function success() {
        $scope.loading = false;
      },
      function error() {}
    );
  };

  function loadFirstPage(firstItems) {
    itemIdLookup = {};
    $scope.items = [];

    if (firstItems !== undefined) {
      angular.forEach(firstItems, function(item) {
        $scope.items.push(item);
        itemIdLookup[item.id] = true;
      });
    }

    $scope.loading = true;
    assetsPager.loadFirstPage().then(
      function success() {
        $scope.loading = false;
      },
      function error() {}
    );
  }

  function updateEmptyMessage() {
    const menu = $scope.selectedMenu;
    const type = menu.fullLabel ? menu.fullLabel : menu.label;
    $scope.emptyMessage = avatarConstantService.assets.emptyMessage(type);
  }

  function isActiveTab() {
    return $scope.selectedTab.tabType === 'Assets';
  }

  $scope.$on(avatarConstantService.events.wornAssetsChanged, function(event, assetIds) {
    angular.forEach($scope.items, function(item) {
      $scope.$parent.updateItemSelected(item);
    });
  });

  $scope.$on(avatarConstantService.events.menuClicked, function(event, obj) {
    const { menu } = obj;

    if (isActiveTab()) {
      if (menu.assetType) {
        let assetType;
        if ($scope.isEmotesEnabled) {
          assetType = avatarTypeService.getAssetTypeByName(menu.assetType);
        } else {
          assetType = $scope.getAssetTypeByName(menu.assetType);
        }
        if (assetType) {
          assetsPager.setPagingParameter('assetTypeId', assetType.id);
          updateEmptyMessage();
          loadFirstPage();
        }
      }
    }
  });

  $scope.init = function() {
    $scope.recommendationsData = {
      showRecommendations: false
    };
    assetsPager.setPagingParameter('userId', CurrentUser.userId);
    updateEmptyMessage();
    if (isActiveTab()) {
      loadFirstPage();
    }
  };

  $scope.initEmotes = function(emotesModalData) {
    $scope.isMenuOpen = emotesModalData.isMenuOpen;
    $scope.selectedTab = emotesModalData.selectedTab;
    $scope.selectedMenu = emotesModalData.selectedMenu;
    $scope.selectedCategory = emotesModalData.selectedCategory;
    $scope.selectedSubcategory = emotesModalData.selectedSubcategory;

    $scope.isEmotesEnabled = true; // if they can open the emotes modal, we can assume emotes are enabled

    const firstItems = [];
    if (emotesModalData.selectedItem !== undefined && emotesModalData.selectedItem !== null) {
      firstItems.push(emotesModalData.selectedItem);
    }

    const assetType = emotesModalData.assetTypeInfo;
    if (assetType) {
      assetsPager.setPagingParameter('assetTypeId', assetType.id);
      assetsPager.setPagingParameter('userId', CurrentUser.userId);
      updateEmptyMessage();
      loadFirstPage(firstItems);
    }
  };
}

avatarModule.controller('avatarItemsController', avatarItemsController);

export default avatarItemsController;
